import { Dialog } from 'primereact/dialog'
import React, { useRef, useState } from 'react'
import { Formik } from 'formik'
import { useTranslation } from 'react-i18next'
import { InputNumber } from 'primereact/inputnumber'
import SharedInputText from '../components/Shared/SharedInputText'
import SharedButton from '../components/Shared/SharedButton'
import { Toast } from 'primereact/toast'
import supergitHIS from '../api/supergitHIS'

export default function StoreRevokeUpdate (props) {
  const { visible, setVisible, revokeData, setRevokeData } = props
  const { t } = useTranslation()
  const formikRef = useRef(null)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const formatDate = dateString => {
    if (!dateString) return ''
    const date = new Date(dateString)
    return date.toLocaleDateString()
  }

  const formatCurrency = amount => {
    if (amount === undefined || amount === null) return '0.00'
    return parseFloat(amount).toFixed(2)
  }

  const initialValues = {
    ClientName: revokeData?.revoke?.ClientName || '',
    ClientID: revokeData?.revoke?.ClientID || '',
    ClientOrderID: revokeData?.revoke?.ClientOrderID || '',
    RevokeDate: revokeData?.revoke?.RevokeDate || '',
    StoreID: revokeData?.revoke?.StoreID || '',
    ClientAddress: revokeData?.revoke?.ClientAddress || '',
    ClientPhone:
      revokeData?.revoke?.ClientPhone ||
      revokeData?.revoke?.ReferencePhone ||
      '',
    ReferenceName: revokeData?.revoke?.ReferenceName || '',
    RevokeAmount: revokeData?.revoke?.RevokeAmount || 0,
    InvoiceId: revokeData?.revoke?.InvoiceId || '',
    LocalSerial: revokeData?.revoke?.LocalSerial || '',
    Status: revokeData?.revoke?.Status || '0',
    Notes: revokeData?.revoke?.Notes || '',
    RevokeReason: revokeData?.revoke?.RevokeReason || '',
    RevokeBy: revokeData?.revoke?.RevokeBy || '',
    RevokeTime: revokeData?.revoke?.RevokeTime || '',
    items: revokeData?.details || []
  }

  const handleSubmit = async values => {
    setIsSubmitting(true)
    try {
      const { items, ...rest } = values
      const payload = {
        details: [...items],
        revoke: {
          ...revokeData?.revoke,
          ...rest,
          RevokeDate: new Date(rest?.RevokeDate).toISOString()
        }
      }
      console.log(payload)

      setVisible(false)
    } catch (error) {
      console.error('Submission error:', error)
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <>
      <Dialog
        header={t('Edit Order')}
        visible={visible}
        onHide={() => {
          setVisible(false)
          setRevokeData(null)
        }}
        pt={{
          root: { className: 'w-full lg:w-10/12 mx-4 overflow-auto' },
          header: { className: '!p-2 !bg-darkBg !text-white' },
          content: { className: '!p-3' },
          closeButton: {
            className: 'hover:!bg-black/20 !outline-none !shadow-none'
          },
          closeButtonIcon: { className: '!text-white' }
        }}
      >
        <Formik
          innerRef={formikRef}
          initialValues={initialValues}
          onSubmit={handleSubmit}
        >
          {formik => (
            <>
              <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 w-full mb-6'>
                <SharedInputText
                  label={t('Client Name')}
                  name='ClientName'
                  value={formik.values.ClientName}
                  onChange={formik.handleChange}
                  className='!p-1.5'
                />
                <SharedInputText
                  label={t('Revoke Date')}
                  type='date'
                  name='RevokeDate'
                  value={
                    new Date(formik.values.RevokeDate)
                      .toISOString()
                      .split('T')[0]
                  }
                  className='!p-1.5'
                />
                <SharedInputText
                  label={t('Store ID')}
                  name='StoreID'
                  value={formik.values.StoreID}
                  onChange={formik.handleChange}
                  className='!p-1.5'
                />
                <SharedInputText
                  label={t('Address')}
                  name='ClientAddress'
                  value={formik.values.ClientAddress}
                  onChange={formik.handleChange}
                  className='!p-1.5'
                />
                <SharedInputText
                  label={t('Phone')}
                  name='ClientPhone'
                  value={formik.values.ClientPhone}
                  onChange={formik.handleChange}
                  className='!p-1.5'
                />
                <SharedInputText
                  label={t('Sales Person')}
                  name='ReferenceName'
                  value={formik.values.ReferenceName}
                  onChange={formik.handleChange}
                  className='!p-1.5'
                />
                <SharedInputText
                  label={t('Revoke Amount')}
                  name='RevokeAmount'
                  value={`${formatCurrency(formik.values.RevokeAmount)} SAR`}
                  readOnly
                  className='!p-1.5'
                />
                <SharedInputText
                  label={t('Invoice ID')}
                  name='InvoiceId'
                  value={formik.values.InvoiceId}
                  className='!p-1.5'
                />
                <SharedInputText
                  label={t('Local Serial')}
                  name='LocalSerial'
                  value={formik.values.LocalSerial}
                  onChange={formik.handleChange}
                  className='!p-1.5'
                />
                <SharedInputText
                  label={t('Status')}
                  name='Status'
                  value={formik.values.Status === '1' ? t('Paid') : t('Unpaid')}
                  readOnly
                  className='!p-1.5'
                />
                <SharedInputText
                  label={t('Comment')}
                  name='Notes'
                  value={formik.values.Notes}
                  onChange={formik.handleChange}
                  className='!p-1.5'
                />
                <SharedInputText
                  label={t('Revoke Reason')}
                  name='RevokeReason'
                  value={formik.values.RevokeReason}
                  onChange={formik.handleChange}
                  className='!p-1.5'
                />
                <SharedInputText
                  label={t('Revoke By')}
                  name='RevokeBy'
                  value={formik.values.RevokeBy}
                  readOnly
                  className='!p-1.5'
                />
                <SharedInputText
                  label={t('Revoke Time')}
                  name='RevokeTime'
                  value={formatDate(formik.values.RevokeTime)}
                  readOnly
                  className='!p-1.5'
                />
              </div>
              <div className='mt-6'>
                <h3 className='text-lg font-semibold mb-4'>
                  {t('Order Items')}
                </h3>

                <div className='overflow-x-auto'>
                  <table className='min-w-full divide-y divide-gray-200'>
                    <thead className='bg-gray-50'>
                      <tr>
                        <th className='px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
                          {t('Code')}
                        </th>
                        <th className='px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
                          {t('Description')}
                        </th>
                        <th className='px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
                          {t('Qty')}
                        </th>
                        <th className='px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
                          {t('Unit Price')}
                        </th>
                        <th className='px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
                          {t('Total Price')}
                        </th>
                        <th className='px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
                          {t('Retail Price')}
                        </th>
                        <th className='px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider'>
                          {t('Cost Price')}
                        </th>
                      </tr>
                    </thead>
                    <tbody className='bg-white divide-y divide-gray-200'>
                      {formik.values.items.map((item, index) => (
                        <tr key={index}>
                          <td className='px-6 py-4 whitespace-nowrap'>
                            <SharedInputText
                              name={`items[${index}].ProductCode`}
                              value={item.ProductCode}
                              className='!p-1.5 !m-0 w-full'
                              onChange={e =>
                                formik.setFieldValue(
                                  `items[${index}].ProductCode`,
                                  e.target.value
                                )
                              }
                            />
                          </td>
                          <td className='px-6 py-4 whitespace-nowrap'>
                            <SharedInputText
                              name={`items[${index}].Description`}
                              value={
                                item.Description || item.PrintInvoiceDescription
                              }
                              className='!p-1.5 !m-0 w-full'
                              onChange={e =>
                                formik.setFieldValue(
                                  `items[${index}].Description`,
                                  e.target.value
                                )
                              }
                            />
                          </td>
                          <td className='px-6 py-4 whitespace-nowrap'>
                            <InputNumber
                              value={item.Quantity}
                              name={`items[${index}].Quantity`}
                              mode='decimal'
                              min={1}
                              className='w-full'
                              inputClassName='!p-1.5 !m-0 w-full'
                              onValueChange={e =>
                                formik.setFieldValue(
                                  `items[${index}].Quantity`,
                                  e.value || 0
                                )
                              }
                            />
                          </td>
                          <td className='px-6 py-4 whitespace-nowrap'>
                            <InputNumber
                              value={item.UnitPrice}
                              name={`items[${index}].UnitPrice`}
                              className='w-full'
                              inputClassName='!p-1.5 !m-0 w-full'
                              onValueChange={e =>
                                formik.setFieldValue(
                                  `items[${index}].UnitPrice`,
                                  e.value || 0
                                )
                              }
                            />
                          </td>
                          <td className='px-6 py-4 whitespace-nowrap'>
                            <InputNumber
                              value={item.Quantity * item.UnitPrice}
                              name={`items[${index}].TotalPrice`}
                              className='w-full'
                              inputClassName='!p-1.5 !m-0 w-full'
                              readOnly
                            />
                          </td>
                          <td className='px-6 py-4 whitespace-nowrap'>
                            <InputNumber
                              value={item.RetailPrice}
                              name={`items[${index}].RetailPrice`}
                              className='w-full'
                              inputClassName='!p-1.5 !m-0 w-full'
                              onValueChange={e =>
                                formik.setFieldValue(
                                  `items[${index}].RetailPrice`,
                                  e.value || 0
                                )
                              }
                            />
                          </td>
                          <td className='px-6 py-4 whitespace-nowrap'>
                            <InputNumber
                              value={item.CostPrice}
                              name={`items[${index}].CostPrice`}
                              className='w-full'
                              inputClassName='!p-1.5 !m-0 w-full'
                              onValueChange={e =>
                                formik.setFieldValue(
                                  `items[${index}].CostPrice`,
                                  e.value || 0
                                )
                              }
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className='flex justify-end gap-6 mt-6'>
                <SharedButton
                  icon='pi pi-times'
                  label={t('Cancel')}
                  className='cancel-btn'
                  onClick={() => {
                    setVisible(false)
                    setRevokeData(null)
                    formik.resetForm()
                  }}
                />
                <SharedButton
                  icon='pi pi-check'
                  label={t('Save')}
                  className='submit-btn'
                  onClick={formik.handleSubmit}
                  disabled={isSubmitting}
                  loading={isSubmitting}
                />
              </div>
            </>
          )}
        </Formik>
      </Dialog>
    </>
  )
}
